// extracted by mini-css-extract-plugin
export var circle = "_am-1";
export var exitConfirmationModal = "_am-5";
export var iframe = "_am-0";
export var offline = "_am-3";
export var online = "_am-2";
export var workstationSelectError = "_am-4";